export default __webpack_public_path__ + "static/media/orioir-review.a83f935d.png";